import IconMinus from "@/app/(site)/_components/Atoms/Icons/IconMinus"
import IconPlus from "@/app/(site)/_components/Atoms/Icons/IconPlus"
import { SearchFilter } from "@/lib/depict-client/types/api/ProductListingRequestV3"
import React, { FC } from "react"
import AnimateHeight from "../../../../Atoms/AnimateHeight"
import ButtonText from "../../../../Molecules/ButtonText"
import { FilterState } from "../../filterReducer"
import FilterOption from "../FilterOptions"

type FilterItemsProps = {
    filters: SearchFilter[]
    selectedFiltersOptions: FilterState
    handleToggleAccordion: (index: number) => void
    activeAccordions: boolean[]
    setFilter: (
        field: string,
        op: string,
        value: string | string[] | number | number[],
        e: React.MouseEvent<HTMLDivElement>
    ) => void
}

const FilterItems: FC<FilterItemsProps> = ({
    filters,
    selectedFiltersOptions,
    handleToggleAccordion,
    activeAccordions,
    setFilter
}) => {
    return (
        <div className="max-h-[calc(100vh-220px)] overflow-y-auto px-4">
            {filters.map((filter, filterIndex) => {
                const activeFilter = selectedFiltersOptions.filters.find(
                    option => option.field === filter.field
                )
                const activeCount = activeFilter ? activeFilter.data.length : 0
                return (
                    <div key={`${filter.id}-${filter.field}`} className="px-16">
                        <div className="flex cursor-pointer border-t-2 border-black py-16">
                            <ButtonText
                                asChild
                                size="big"
                                onClick={() => handleToggleAccordion(filterIndex)}
                                iconPosition="right"
                                className="flex w-full justify-between"
                                icon={
                                    activeAccordions[filterIndex] ? (
                                        <IconMinus className="ml-auto h-20 w-20" />
                                    ) : (
                                        <IconPlus className="ml-auto h-20 w-20" />
                                    )
                                }
                                weight="regular"
                                role="button"
                                aria-label={`Open ${filter.meta?.group_title} filter`}
                            >
                                {/* translated by depict */}
                                {filter.meta?.group_title}
                                {activeCount > 0 && ` (${activeCount})`}
                            </ButtonText>
                        </div>
                        <AnimateHeight
                            minified={!activeAccordions[filterIndex]}
                            className="transition-all duration-300 ease-in-out"
                        >
                            <div className="mb-32 flex flex-col space-y-8">
                                <FilterOption
                                    filter={filter}
                                    selectedFilters={
                                        selectedFiltersOptions?.filters || []
                                    }
                                    setFilter={setFilter}
                                />
                            </div>
                        </AnimateHeight>
                    </div>
                )
            })}
        </div>
    )
}

export default FilterItems
